export const FishIcon = () => (
    <svg viewBox="0 0 57 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
        <path
            d="M24.63 31.667c8.904 0 16.68-5.42 21.007-10.058l8.642 6.537c1.2.908 2.992-.06 2.685-1.451l-2.392-10.862 2.393-10.862c.307-1.392-1.485-2.359-2.685-1.451l-8.642 6.536C41.31 5.42 33.534 0 24.63 0 11.028 0 0 12.667 0 15.833 0 19 11.028 31.667 24.63 31.667ZM15.98 13.458a2.376 2.376 0 1 1-.001 4.752 2.376 2.376 0 0 1 0-4.752Z"
            fill="currentColor"
        />
    </svg>
);
